<template>
  <div id="area" class="slideUp">
    <i id="close" class="anyteachicon anyteach-guanbi" @click="end()" />
    <div class="content-123">
      <div v-if="selectedArea" class="item selected underline">
        <span>{{ cities.filter(item => item.area_id == selectedArea)[0].city }}</span>
        <i class="anyteachicon anyteach-check-circle" />
      </div>
      <div
        v-for="item in cities"
        :key="item.area_id"
        class="item"
        :class="{ selected: item.area_id == selectedArea }"
        @click="select(item.area_id)"
      >
        <div v-if="item.area_id != selectedArea || selectedArea == 0">
          <span>{{ item.city }}</span>
          <i v-if="item.area_id == selectedArea" class="anyteachicon anyteach-check-circle" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Area",
  props: ["areaId"],
  data() {
    return {
      selectedArea: "",
      cities: [
        { area_id: 0, city: "全国" },
        { area_id: 3, city: "深圳" },
        { area_id: 2, city: "厦门" },
        { area_id: 1, city: "泉州" },
      ],
    }
  },
  created() {
    document.body.classList.add("noscroll")
    this.selectedArea = this.area_id
  },
  methods: {
    end() {
      document.getElementById("area").classList.remove("slideUp")
      document.getElementById("area").classList.add("slideDown")
      setTimeout(() => {
        this.$emit("close", this.selectedArea)
        document.body.classList.remove("noscroll")
      }, 300)
    },
    select(id) {
      this.selectedArea = id
      this.end()
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../static/css/public.scss";

#area {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: white;

  z-index: 997;
  display: block;
  margin: 0;
  #close {
    right: 5%;
    position: absolute;
  }
  .content-123 {
    padding: 30px 0 20px 5%;
    overflow-y: scroll;
    height: 100%;
    width: 80%;
    .item {
      font-size: 25px;
      font-weight: 500;
      margin-bottom: 20px;

      &:active {
        color: $red;
      }

      i {
        line-height: 0;
      }
    }

    .selected {
      color: $red;
    }
    .underline {
      border-bottom: 1px solid #eaeaea;
      padding: 0 0 15px 0;
    }
  }
}
</style>
